<!-- AI-T编辑器-媒体-摄像头弹框功能 -->
<template>
  <div class="popup-media-content">
    <!-- 添加摄像头 -->
    <gat-popup
      :class="['popup-camera', popupActive === 'camera' ? 'on' : 'off']"
      :title="'添加摄像头'"
      :primary-button="'false'"
      :cancelButton="'网络-摄像头'"
      :primaryWidth="'180px'"
      :cancelWidth="'180px'"
      @confirm="openCamera2"
      @cancel="cancelOrOpenCamera2"
    >
      <template v-slot:content>
        <div></div>
      </template>
    </gat-popup>
    <!-- 本地摄像头 -->
    <gat-popup
      :class="[
        'popup-local-camera',
        popupActive === 'localCamera' ? 'on' : 'off',
      ]"
      :title="'本地摄像头'"
      :primary-button="'确定添加'"
      :cancelButton="'网络-摄像头'"
      @confirm="confirmLocalCamera"
      @cancel="cancelLocalCamera"
    >
      <template v-slot:content>
        <div class="camera-group">
          <div class="group-2">
            <span class="label-1">本地摄像头名称：</span>
            <el-input
              class="net-camera-url"
              v-model.trim="localCamera.url"
              placeholder="https://image.baidu.com"
            />
            <img class="icon-edite2" :src="iconEdite2" />
            <el-button type="primary" class="pre-view">获取摄像头</el-button>
          </div>

          <div class="camera-view">
            <div class="camera-tooltip">
              <img class="icon-no-message" :src="iconNoMessage" />
              <span>暂无信息！</span>
            </div>
          </div>
        </div>
      </template>
    </gat-popup>
    <!-- 网络摄像头 -->
    <gat-popup
      :class="['popup-net-camera', popupActive === 'net' ? 'on' : 'off']"
      :title="'网络监控摄像头'"
      :primary-button="'确定添加'"
      :cancelButton="'取消'"
      @confirm="confirmNetCamera"
      @cancel="cancelNetCamera"
    >
      <template v-slot:content>
        <div class="camera-group">
          <div class="group-1">
            <span class="label-1">网络摄像头地址：</span>
            <el-input
              class="net-camera-url"
              v-model.trim="netCamera.url"
              placeholder="请输入内容"
            />
          </div>

          <div class="group-2">
            <span class="label-1">监控摄像头名称：</span>
            <el-input
              class="net-camera-url"
              v-model.trim="netCamera.name"
              placeholder="haika-0065"
            />
            <el-button type="primary" class="pre-view" @click="preViewNetCamera"
              >预览
            </el-button>
            <img class="icon-edite2" :src="iconEdite2" />
            <img class="icon-view" :src="iconView" @click="preViewNetCamera" />
          </div>

          <div class="camera-view">
            <!-- img 标签预览网络摄像头 -->
            <img
              id="bg"
              class="net-camera-bg"
              :src="netCamera.path"
              v-if="netCamera.isPreview"
              alt="no camera"
            />
            <div class="camera-tooltip" v-if="!netCamera.isPreview">
              <img class="icon-no-message" :src="iconNoMessage" />
              <span>暂无信息！</span>
            </div>
          </div>
        </div>
      </template>
    </gat-popup>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import blockSvg from '@/components/blocklyEditor/common/BlockSvg.vue'
export default {
  components: {
    GatPopup,
    blockSvg,
  },
  props: {
    popupActive: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconEdite2: require('@/assets/images/icon-edite2.png'),
      iconView: require('@/assets/images/icon-view.png'),
      iconNoMessage: require('@/assets/images/icon-nomessage.png'),
      netCamera: {
        name: '',
        url: window.gtaAiConfig.netCameraObj.url,
        path: '',
        host1: window.gtaAiConfig.netCameraObj.host,
        isPreview: false,
      },
      localCamera: {
        url: '',
      },
      mediaGotten: 0,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    openCamera2(evt) {
      // this.popupActive = 'localCamera'
      this.$emit("update:popupActive", 'localCamera')
    },
    confirmNetCamera() {
      // this.popupActive = '' //关闭弹框
      this.$emit("update:popupActive", '')
      this.$emit('confirmNetCamera', this.netCamera)
    },
    //确定本地摄像头
    confirmLocalCamera() {},
    //预览、获取网络摄像头api
    preViewNetCamera() {
      this.netCamera.path = null //清空路径缓存 
      this.netCamera.path = this.netCamera.host1 + this.netCamera.url
      this.netCamera.isPreview = true
      this.$forceUpdate();
    },
    //取消或者选择网络摄像头
    cancelOrOpenCamera2(evt) {
      if (evt == 'firstOff') {
        //关闭按钮
        // this.popupActive = ''
        this.$emit("update:popupActive", '')
        return
      }
      // this.popupActive = 'net'
      this.$emit("update:popupActive", 'net')
    },
    cancelPopup() {
        // this.popupActive = ''
         this.$emit("update:popupActive", '')
    },
    //取消关闭
    cancelLocalCamera() {
      // this.popupActive = ''
       this.$emit("update:popupActive", '')
    },

    //取消网络摄像头关闭
    cancelNetCamera() {
      // this.popupActive = ''
       this.$emit("update:popupActive", '')
      this.netCamera.isPreview = false
      this.netCamera.path = ''
    },
  },
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.off {
  display: none;
}
.on {
  z-index: 99;
}

.popup-media-content {
  /*  全局样式*/
  .popup-camera {
    width: 480px;
    height: 220px;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
    .cls-1 {
      fill: #4c88ff !important;
    }
    .title {
      color: #4c88ff;
    }
    ::v-deep .popup-inner {
      height: 220px !important;
      max-height: 100% !important;
      padding-bottom: 0px;

      .popup-content {
        font-size: 14px;
        color: #333;
        margin-left: 20px;
        margin-top: 23px;
      }

      .popup-buttons {
        .el-button.primary,
        .el-button.cancel {
          width: 180px;
          height: 36px;
          font-size: 14px;
          line-height: 0px;
        }
        .el-button.cancel {
          background: #fff;
          border: 1px solid #4c88ff;
          color: #4c88ff;
        }
      }
    }
  }
  .popup-net-camera {
    width: 680px;
    height: 660px;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
    .cls-1 {
      fill: #4c88ff !important;
    }
    .title {
      color: #4c88ff;
    }
    ::v-deep .popup-inner {
      width: 680px !important;
      height: 100% !important;
      max-height: 100% !important;
      padding-bottom: 0px;

      .popup-content {
        width: 600px !important;
        margin: 32px auto;
        font-size: 14px;
        color: #333;
        .camera-group {
          .group-1 {
            .net-camera-url {
              // display: inline-block;
              width: 477px;
              margin-left: 10px;
            }
          }
          .group-2 {
            margin-top: -15px;
            .net-camera-url {
              // display: inline-block;
              width: 348px;
              margin-left: 10px;
            }
            .pre-view {
              width: 120px;
              margin-left: 10px;
              transform: translateY(1px);
            }
            .icon-edite2 {
              position: absolute;
              transform: translate(-152px, 42px);
            }
            .icon-view {
              position: absolute;
              transform: translate(-95px, 42px);
              cursor: pointer;
            }
          }
        }
      }
      .popup-buttons {
        bottom: 10px;
      }
      .camera-view {
        width: 600px;
        height: 375px;
        background: #d8e5fd;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .net-camera-bg {
          width: 100%;
          height: 100%;
        }
        .camera-tooltip {
          text-align: center;
          width: 100px;
          flex: 1;
          span {
            text-align: center;
            display: inline-block;
            transform: translate(20px, -8px);
            color: #4c88ff;
          }
        }
      }

      .popup-buttons {
        .el-button.primary {
          width: 180px;
          height: 36px;
          font-size: 14px;
          line-height: 0px;
        }
        .el-button.cancel {
          display: none;
        }
      }
    }
  }
  .popup-local-camera {
    width: 680px;
    height: 610px;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-340px, -305px);
    .cls-1 {
      fill: #4c88ff !important;
    }
    .title {
      color: #4c88ff;
    }
    ::v-deep .popup-inner {
      width: 680px !important;
      height: 100% !important;
      max-height: 100% !important;
      padding-bottom: 0px;

      .popup-content {
        width: 600px !important;
        margin: 32px auto;
        font-size: 14px;
        color: #333;
        .camera-group {
          .group-1 {
            .net-camera-url {
              // display: inline-block;
              width: 477px;
              margin-left: 10px;
            }
          }
          .group-2 {
            margin-top: -15px;
            .net-camera-url {
              // display: inline-block;
              width: 348px;
              margin-left: 10px;
            }
            .pre-view {
              width: 120px;
              margin-left: 10px;
              transform: translateY(1px);
              background: #f0f5ff;
              border: 1px solid #4c88ff;
              color: #4c88ff;
            }
            .icon-edite2 {
              position: absolute;
              transform: translate(-25px, 42px);
            }
          }
        }
        .camera-view {
          width: 600px;
          height: 375px;
          background: #d8e5fd;
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          .camera-tooltip {
            text-align: center;
            width: 100px;
            flex: 1;
            span {
              text-align: center;
              display: inline-block;
              transform: translate(20px, -8px);
              color: #4c88ff;
            }
          }
        }
      }

      .popup-buttons {
        .el-button.primary {
          width: 180px;
          height: 36px;
          font-size: 14px;
          line-height: 0px;
        }
        .el-button.cancel {
          display: none;
        }
      }
    }
  }
}
</style>
